export const getRealmRolesFromToken = (token?: string | null): string[] => {
  if (!token) return [];
  try {
    const [, payload] = (token || '').split('.');
    if (!payload) return [];
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    const roles: string[] = json?.realm_access?.roles || [];
    return Array.isArray(roles) ? roles : [];
  } catch {
    return [];
  }
};

